import React from 'react'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import Relazsizes from 'relazsizes'
import config from 'config'
import PeluangBenefitData from './PeluangBenefitData.json'

const { assets_url: assetsUrl } = config
const peluangAssetsPath = `${assetsUrl}/assets/img/peluang/benefit`

const PeluangBenefit = () => (
  <div className="peluang-benefit" id="peluang-benefit">
    <SectionContainer
      backgroundColor="transparent"
    >
      <Container>
        <Typography component="h2" variant="title-sm" className="m-b-lg">
          Bagaimana cara Cek Peluang SBMPTN?
        </Typography>
        <div className="peluang-benefit__row">
          {
            PeluangBenefitData.map((item, idx) => (
              <div className="peluang-benefit__col" key={`peluang-benefit-itm-${idx}`}>
                <Relazsizes dataSrc={`${peluangAssetsPath}/${item.image}.png`} alt={item.altImage} className="peluang-benefit__img" />
                <Typography variant="headline" component="h6" className="m-t-lg m-b-md">{item.title}</Typography>
                <Typography variant="subheading" component="p">{item.description}</Typography>
              </div>
            ))
          }
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .peluang-benefit {
          text-align: center;
          padding-top: 100px;
          &__row {
            display: flex;
          }
          &__col {
            flex-basis: 50%;
            padding: 20px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 8px 16px 0 rgba(30, 63, 107, 0.15);
            &:not(:last-child) {
              margin-right: 20px;
            }
          }
          @media screen and (max-width: 767px) {
            &__row {
              flex-direction: column;
            }
            &__col {
              margin-right: 0 !important;
              &:not(:last-child) {
                margin-bottom: 20px;
              }
            }
          }
        }
      `}
    </style>
  </div>
)

export default PeluangBenefit
